import { default as aboutu8Sb32ihwPMeta } from "/app/pages/about.vue?macro=true";
import { default as agreementY82GsiR81fMeta } from "/app/pages/agreement.vue?macro=true";
import { default as _91id_93ScmcGUcI4JMeta } from "/app/pages/ai/report/[id].vue?macro=true";
import { default as indexZOBGoXPH3YMeta } from "/app/pages/ai/report/index.vue?macro=true";
import { default as _91id_933W08RmjplwMeta } from "/app/pages/analysis/blogger/detail/[id].vue?macro=true";
import { default as ecommerceoPWDjRJwwFMeta } from "/app/pages/analysis/blogger/ecommerce.vue?macro=true";
import { default as increaseFanszdwuqL05TLMeta } from "/app/pages/analysis/blogger/increaseFans.vue?macro=true";
import { default as index1JzR77fDk9Meta } from "/app/pages/analysis/blogger/index.vue?macro=true";
import { default as _91id_93eEl2pjURgnMeta } from "/app/pages/analysis/live/detail/[id].vue?macro=true";
import { default as ecommerce5Bh2oBih01Meta } from "/app/pages/analysis/live/ecommerce.vue?macro=true";
import { default as indexObEO00WlCMMeta } from "/app/pages/analysis/live/index.vue?macro=true";
import { default as _91id_937ognwgTcAhMeta } from "/app/pages/analysis/products/detail/[id].vue?macro=true";
import { default as hotPushWjcxNu4Y2QMeta } from "/app/pages/analysis/products/hotPush.vue?macro=true";
import { default as hotSale1QPgdKQYnIMeta } from "/app/pages/analysis/products/hotSale.vue?macro=true";
import { default as indexskMVpjdDJjMeta } from "/app/pages/analysis/products/index.vue?macro=true";
import { default as bloggerInteractCTZLiBP746Meta } from "/app/pages/analysis/shop/bloggerInteract.vue?macro=true";
import { default as _91id_93jhLEC1HqhnMeta } from "/app/pages/analysis/shop/detail/[id].vue?macro=true";
import { default as hostingZl8UY9gg8gMeta } from "/app/pages/analysis/shop/hosting.vue?macro=true";
import { default as hotSaleAhiRrB7sPXMeta } from "/app/pages/analysis/shop/hotSale.vue?macro=true";
import { default as indexePe1Rp0qLFMeta } from "/app/pages/analysis/shop/index.vue?macro=true";
import { default as _91id_93KTHUBNq7d5Meta } from "/app/pages/analysis/video/detail/[id].vue?macro=true";
import { default as ecommerceessWGKbLmBMeta } from "/app/pages/analysis/video/ecommerce.vue?macro=true";
import { default as hotHmiq9TiS3SMeta } from "/app/pages/analysis/video/hot.vue?macro=true";
import { default as indexyg5FbxbnzUMeta } from "/app/pages/analysis/video/index.vue?macro=true";
import { default as _91slug_93cdf2dv6FbPMeta } from "/app/pages/blog/[slug].vue?macro=true";
import { default as eventrnRSHV1LeRMeta } from "/app/pages/blog/event.vue?macro=true";
import { default as indexgWaMlevJ7RMeta } from "/app/pages/blog/index.vue?macro=true";
import { default as marketvo5RpeWqlxMeta } from "/app/pages/blog/market.vue?macro=true";
import { default as _91category_93PvkHdqkLZeMeta } from "/app/pages/blog/study/[category].vue?macro=true";
import { default as indexBdHGb1d4asMeta } from "/app/pages/blog/study/index.vue?macro=true";
import { default as _91slug_933eBzGbcZ9XMeta } from "/app/pages/content/[slug].vue?macro=true";
import { default as analysistH66duiY95Meta } from "/app/pages/content/analysis.vue?macro=true";
import { default as _91id_934xfDEMQK1fMeta } from "/app/pages/content/detail/[id].vue?macro=true";
import { default as indexryMIhEy6m5Meta } from "/app/pages/content/index.vue?macro=true";
import { default as newsAdFAajK46MMeta } from "/app/pages/content/news.vue?macro=true";
import { default as contrastb2yonltQGeMeta } from "/app/pages/creative/contrast.vue?macro=true";
import { default as indexYvxSwphbvdMeta } from "/app/pages/creative/index.vue?macro=true";
import { default as excel_45image_45tutoriallfzrtrj7UvMeta } from "/app/pages/excel-image-tutorial.vue?macro=true";
import { default as blogger9WubeqXVr2Meta } from "/app/pages/favourites/blogger.vue?macro=true";
import { default as liver3gvoCoFJZMeta } from "/app/pages/favourites/live.vue?macro=true";
import { default as productx8BV4WBV7FMeta } from "/app/pages/favourites/product.vue?macro=true";
import { default as shophd5slMypvlMeta } from "/app/pages/favourites/shop.vue?macro=true";
import { default as videosId3EEkwbsMeta } from "/app/pages/favourites/video.vue?macro=true";
import { default as favourites2FBJJbkfd4Meta } from "/app/pages/favourites.vue?macro=true";
import { default as indexN6pT4Un8hYMeta } from "/app/pages/index.vue?macro=true";
import { default as invitebE9by1aL3FMeta } from "/app/pages/invite.vue?macro=true";
import { default as analysiszTAOL1xGgBMeta } from "/app/pages/marketing/analysis.vue?macro=true";
import { default as overviewEoxmshHrAiMeta } from "/app/pages/marketing/overview.vue?macro=true";
import { default as _91id_93ajJAov56K2Meta } from "/app/pages/marketing/segment/detail/[id].vue?macro=true";
import { default as indexFoa8368a6XMeta } from "/app/pages/marketing/segment/index.vue?macro=true";
import { default as pt3NYoboDcLsMeta } from "/app/pages/pay/pt.vue?macro=true";
import { default as privacyg3gwBRGXatMeta } from "/app/pages/privacy.vue?macro=true";
import { default as serviceOjoihKJKpkMeta } from "/app/pages/service.vue?macro=true";
import { default as bloggerMonitorYPKxvI7WQwMeta } from "/app/pages/tool/bloggerMonitor.vue?macro=true";
import { default as bloggers31RjXDiUlJMeta } from "/app/pages/tool/bloggers.vue?macro=true";
import { default as pay3ZDuAlPusyMeta } from "/app/pages/tool/pay.vue?macro=true";
import { default as videoMonitor401vq3KfplMeta } from "/app/pages/tool/videoMonitor.vue?macro=true";
import { default as infoaWsS3RStYaMeta } from "/app/pages/user/info.vue?macro=true";
import { default as memberSMZBlN5QGVMeta } from "/app/pages/user/member.vue?macro=true";
import { default as order4BxZtw60EvMeta } from "/app/pages/user/order.vue?macro=true";
import { default as userCXh5rkXRCzMeta } from "/app/pages/user.vue?macro=true";
import { default as checkKLfImkaWt2Meta } from "/app/pages/vip/check.vue?macro=true";
import { default as indextrgzWvQsEDMeta } from "/app/pages/vip/index.vue?macro=true";
export default [
  {
    name: "about___en",
    path: "/en/about",
    meta: aboutu8Sb32ihwPMeta || {},
    component: () => import("/app/pages/about.vue").then(m => m.default || m)
  },
  {
    name: "about___zh___default",
    path: "/about",
    meta: aboutu8Sb32ihwPMeta || {},
    component: () => import("/app/pages/about.vue").then(m => m.default || m)
  },
  {
    name: "about___zh",
    path: "/zh/about",
    meta: aboutu8Sb32ihwPMeta || {},
    component: () => import("/app/pages/about.vue").then(m => m.default || m)
  },
  {
    name: "about___pt",
    path: "/pt/about",
    meta: aboutu8Sb32ihwPMeta || {},
    component: () => import("/app/pages/about.vue").then(m => m.default || m)
  },
  {
    name: "agreement___en",
    path: "/en/agreement",
    meta: agreementY82GsiR81fMeta || {},
    component: () => import("/app/pages/agreement.vue").then(m => m.default || m)
  },
  {
    name: "agreement___zh___default",
    path: "/agreement",
    meta: agreementY82GsiR81fMeta || {},
    component: () => import("/app/pages/agreement.vue").then(m => m.default || m)
  },
  {
    name: "agreement___zh",
    path: "/zh/agreement",
    meta: agreementY82GsiR81fMeta || {},
    component: () => import("/app/pages/agreement.vue").then(m => m.default || m)
  },
  {
    name: "agreement___pt",
    path: "/pt/agreement",
    meta: agreementY82GsiR81fMeta || {},
    component: () => import("/app/pages/agreement.vue").then(m => m.default || m)
  },
  {
    name: "ai-report-id___en",
    path: "/en/ai/report/:id()",
    meta: _91id_93ScmcGUcI4JMeta || {},
    component: () => import("/app/pages/ai/report/[id].vue").then(m => m.default || m)
  },
  {
    name: "ai-report-id___zh___default",
    path: "/ai/report/:id()",
    meta: _91id_93ScmcGUcI4JMeta || {},
    component: () => import("/app/pages/ai/report/[id].vue").then(m => m.default || m)
  },
  {
    name: "ai-report-id___zh",
    path: "/zh/ai/report/:id()",
    meta: _91id_93ScmcGUcI4JMeta || {},
    component: () => import("/app/pages/ai/report/[id].vue").then(m => m.default || m)
  },
  {
    name: "ai-report-id___pt",
    path: "/pt/ai/report/:id()",
    meta: _91id_93ScmcGUcI4JMeta || {},
    component: () => import("/app/pages/ai/report/[id].vue").then(m => m.default || m)
  },
  {
    name: "ai-report___en",
    path: "/en/ai/report",
    meta: indexZOBGoXPH3YMeta || {},
    component: () => import("/app/pages/ai/report/index.vue").then(m => m.default || m)
  },
  {
    name: "ai-report___zh___default",
    path: "/ai/report",
    meta: indexZOBGoXPH3YMeta || {},
    component: () => import("/app/pages/ai/report/index.vue").then(m => m.default || m)
  },
  {
    name: "ai-report___zh",
    path: "/zh/ai/report",
    meta: indexZOBGoXPH3YMeta || {},
    component: () => import("/app/pages/ai/report/index.vue").then(m => m.default || m)
  },
  {
    name: "ai-report___pt",
    path: "/pt/ai/report",
    meta: indexZOBGoXPH3YMeta || {},
    component: () => import("/app/pages/ai/report/index.vue").then(m => m.default || m)
  },
  {
    name: "analysis-blogger-detail-id___en",
    path: "/en/analysis/blogger/detail/:id()",
    meta: _91id_933W08RmjplwMeta || {},
    component: () => import("/app/pages/analysis/blogger/detail/[id].vue").then(m => m.default || m)
  },
  {
    name: "analysis-blogger-detail-id___zh___default",
    path: "/analysis/blogger/detail/:id()",
    meta: _91id_933W08RmjplwMeta || {},
    component: () => import("/app/pages/analysis/blogger/detail/[id].vue").then(m => m.default || m)
  },
  {
    name: "analysis-blogger-detail-id___zh",
    path: "/zh/analysis/blogger/detail/:id()",
    meta: _91id_933W08RmjplwMeta || {},
    component: () => import("/app/pages/analysis/blogger/detail/[id].vue").then(m => m.default || m)
  },
  {
    name: "analysis-blogger-detail-id___pt",
    path: "/pt/analysis/blogger/detail/:id()",
    meta: _91id_933W08RmjplwMeta || {},
    component: () => import("/app/pages/analysis/blogger/detail/[id].vue").then(m => m.default || m)
  },
  {
    name: "analysis-blogger-ecommerce___en",
    path: "/en/analysis/blogger/ecommerce",
    meta: ecommerceoPWDjRJwwFMeta || {},
    component: () => import("/app/pages/analysis/blogger/ecommerce.vue").then(m => m.default || m)
  },
  {
    name: "analysis-blogger-ecommerce___zh___default",
    path: "/analysis/blogger/ecommerce",
    meta: ecommerceoPWDjRJwwFMeta || {},
    component: () => import("/app/pages/analysis/blogger/ecommerce.vue").then(m => m.default || m)
  },
  {
    name: "analysis-blogger-ecommerce___zh",
    path: "/zh/analysis/blogger/ecommerce",
    meta: ecommerceoPWDjRJwwFMeta || {},
    component: () => import("/app/pages/analysis/blogger/ecommerce.vue").then(m => m.default || m)
  },
  {
    name: "analysis-blogger-ecommerce___pt",
    path: "/pt/analysis/blogger/ecommerce",
    meta: ecommerceoPWDjRJwwFMeta || {},
    component: () => import("/app/pages/analysis/blogger/ecommerce.vue").then(m => m.default || m)
  },
  {
    name: "analysis-blogger-increaseFans___en",
    path: "/en/analysis/blogger/increaseFans",
    meta: increaseFanszdwuqL05TLMeta || {},
    component: () => import("/app/pages/analysis/blogger/increaseFans.vue").then(m => m.default || m)
  },
  {
    name: "analysis-blogger-increaseFans___zh___default",
    path: "/analysis/blogger/increaseFans",
    meta: increaseFanszdwuqL05TLMeta || {},
    component: () => import("/app/pages/analysis/blogger/increaseFans.vue").then(m => m.default || m)
  },
  {
    name: "analysis-blogger-increaseFans___zh",
    path: "/zh/analysis/blogger/increaseFans",
    meta: increaseFanszdwuqL05TLMeta || {},
    component: () => import("/app/pages/analysis/blogger/increaseFans.vue").then(m => m.default || m)
  },
  {
    name: "analysis-blogger-increaseFans___pt",
    path: "/pt/analysis/blogger/increaseFans",
    meta: increaseFanszdwuqL05TLMeta || {},
    component: () => import("/app/pages/analysis/blogger/increaseFans.vue").then(m => m.default || m)
  },
  {
    name: "analysis-blogger___en",
    path: "/en/analysis/blogger",
    meta: index1JzR77fDk9Meta || {},
    component: () => import("/app/pages/analysis/blogger/index.vue").then(m => m.default || m)
  },
  {
    name: "analysis-blogger___zh___default",
    path: "/analysis/blogger",
    meta: index1JzR77fDk9Meta || {},
    component: () => import("/app/pages/analysis/blogger/index.vue").then(m => m.default || m)
  },
  {
    name: "analysis-blogger___zh",
    path: "/zh/analysis/blogger",
    meta: index1JzR77fDk9Meta || {},
    component: () => import("/app/pages/analysis/blogger/index.vue").then(m => m.default || m)
  },
  {
    name: "analysis-blogger___pt",
    path: "/pt/analysis/blogger",
    meta: index1JzR77fDk9Meta || {},
    component: () => import("/app/pages/analysis/blogger/index.vue").then(m => m.default || m)
  },
  {
    name: "analysis-live-detail-id___en",
    path: "/en/analysis/live/detail/:id()",
    meta: _91id_93eEl2pjURgnMeta || {},
    component: () => import("/app/pages/analysis/live/detail/[id].vue").then(m => m.default || m)
  },
  {
    name: "analysis-live-detail-id___zh___default",
    path: "/analysis/live/detail/:id()",
    meta: _91id_93eEl2pjURgnMeta || {},
    component: () => import("/app/pages/analysis/live/detail/[id].vue").then(m => m.default || m)
  },
  {
    name: "analysis-live-detail-id___zh",
    path: "/zh/analysis/live/detail/:id()",
    meta: _91id_93eEl2pjURgnMeta || {},
    component: () => import("/app/pages/analysis/live/detail/[id].vue").then(m => m.default || m)
  },
  {
    name: "analysis-live-detail-id___pt",
    path: "/pt/analysis/live/detail/:id()",
    meta: _91id_93eEl2pjURgnMeta || {},
    component: () => import("/app/pages/analysis/live/detail/[id].vue").then(m => m.default || m)
  },
  {
    name: "analysis-live-ecommerce___en",
    path: "/en/analysis/live/ecommerce",
    meta: ecommerce5Bh2oBih01Meta || {},
    component: () => import("/app/pages/analysis/live/ecommerce.vue").then(m => m.default || m)
  },
  {
    name: "analysis-live-ecommerce___zh___default",
    path: "/analysis/live/ecommerce",
    meta: ecommerce5Bh2oBih01Meta || {},
    component: () => import("/app/pages/analysis/live/ecommerce.vue").then(m => m.default || m)
  },
  {
    name: "analysis-live-ecommerce___zh",
    path: "/zh/analysis/live/ecommerce",
    meta: ecommerce5Bh2oBih01Meta || {},
    component: () => import("/app/pages/analysis/live/ecommerce.vue").then(m => m.default || m)
  },
  {
    name: "analysis-live-ecommerce___pt",
    path: "/pt/analysis/live/ecommerce",
    meta: ecommerce5Bh2oBih01Meta || {},
    component: () => import("/app/pages/analysis/live/ecommerce.vue").then(m => m.default || m)
  },
  {
    name: "analysis-live___en",
    path: "/en/analysis/live",
    meta: indexObEO00WlCMMeta || {},
    component: () => import("/app/pages/analysis/live/index.vue").then(m => m.default || m)
  },
  {
    name: "analysis-live___zh___default",
    path: "/analysis/live",
    meta: indexObEO00WlCMMeta || {},
    component: () => import("/app/pages/analysis/live/index.vue").then(m => m.default || m)
  },
  {
    name: "analysis-live___zh",
    path: "/zh/analysis/live",
    meta: indexObEO00WlCMMeta || {},
    component: () => import("/app/pages/analysis/live/index.vue").then(m => m.default || m)
  },
  {
    name: "analysis-live___pt",
    path: "/pt/analysis/live",
    meta: indexObEO00WlCMMeta || {},
    component: () => import("/app/pages/analysis/live/index.vue").then(m => m.default || m)
  },
  {
    name: "analysis-products-detail-id___en",
    path: "/en/analysis/products/detail/:id()",
    meta: _91id_937ognwgTcAhMeta || {},
    component: () => import("/app/pages/analysis/products/detail/[id].vue").then(m => m.default || m)
  },
  {
    name: "analysis-products-detail-id___zh___default",
    path: "/analysis/products/detail/:id()",
    meta: _91id_937ognwgTcAhMeta || {},
    component: () => import("/app/pages/analysis/products/detail/[id].vue").then(m => m.default || m)
  },
  {
    name: "analysis-products-detail-id___zh",
    path: "/zh/analysis/products/detail/:id()",
    meta: _91id_937ognwgTcAhMeta || {},
    component: () => import("/app/pages/analysis/products/detail/[id].vue").then(m => m.default || m)
  },
  {
    name: "analysis-products-detail-id___pt",
    path: "/pt/analysis/products/detail/:id()",
    meta: _91id_937ognwgTcAhMeta || {},
    component: () => import("/app/pages/analysis/products/detail/[id].vue").then(m => m.default || m)
  },
  {
    name: "analysis-products-hotPush___en",
    path: "/en/analysis/products/hotPush",
    meta: hotPushWjcxNu4Y2QMeta || {},
    component: () => import("/app/pages/analysis/products/hotPush.vue").then(m => m.default || m)
  },
  {
    name: "analysis-products-hotPush___zh___default",
    path: "/analysis/products/hotPush",
    meta: hotPushWjcxNu4Y2QMeta || {},
    component: () => import("/app/pages/analysis/products/hotPush.vue").then(m => m.default || m)
  },
  {
    name: "analysis-products-hotPush___zh",
    path: "/zh/analysis/products/hotPush",
    meta: hotPushWjcxNu4Y2QMeta || {},
    component: () => import("/app/pages/analysis/products/hotPush.vue").then(m => m.default || m)
  },
  {
    name: "analysis-products-hotPush___pt",
    path: "/pt/analysis/products/hotPush",
    meta: hotPushWjcxNu4Y2QMeta || {},
    component: () => import("/app/pages/analysis/products/hotPush.vue").then(m => m.default || m)
  },
  {
    name: "analysis-products-hotSale___en",
    path: "/en/analysis/products/hotSale",
    meta: hotSale1QPgdKQYnIMeta || {},
    component: () => import("/app/pages/analysis/products/hotSale.vue").then(m => m.default || m)
  },
  {
    name: "analysis-products-hotSale___zh___default",
    path: "/analysis/products/hotSale",
    meta: hotSale1QPgdKQYnIMeta || {},
    component: () => import("/app/pages/analysis/products/hotSale.vue").then(m => m.default || m)
  },
  {
    name: "analysis-products-hotSale___zh",
    path: "/zh/analysis/products/hotSale",
    meta: hotSale1QPgdKQYnIMeta || {},
    component: () => import("/app/pages/analysis/products/hotSale.vue").then(m => m.default || m)
  },
  {
    name: "analysis-products-hotSale___pt",
    path: "/pt/analysis/products/hotSale",
    meta: hotSale1QPgdKQYnIMeta || {},
    component: () => import("/app/pages/analysis/products/hotSale.vue").then(m => m.default || m)
  },
  {
    name: "analysis-products___en",
    path: "/en/analysis/products",
    meta: indexskMVpjdDJjMeta || {},
    component: () => import("/app/pages/analysis/products/index.vue").then(m => m.default || m)
  },
  {
    name: "analysis-products___zh___default",
    path: "/analysis/products",
    meta: indexskMVpjdDJjMeta || {},
    component: () => import("/app/pages/analysis/products/index.vue").then(m => m.default || m)
  },
  {
    name: "analysis-products___zh",
    path: "/zh/analysis/products",
    meta: indexskMVpjdDJjMeta || {},
    component: () => import("/app/pages/analysis/products/index.vue").then(m => m.default || m)
  },
  {
    name: "analysis-products___pt",
    path: "/pt/analysis/products",
    meta: indexskMVpjdDJjMeta || {},
    component: () => import("/app/pages/analysis/products/index.vue").then(m => m.default || m)
  },
  {
    name: "analysis-shop-bloggerInteract___en",
    path: "/en/analysis/shop/bloggerInteract",
    meta: bloggerInteractCTZLiBP746Meta || {},
    component: () => import("/app/pages/analysis/shop/bloggerInteract.vue").then(m => m.default || m)
  },
  {
    name: "analysis-shop-bloggerInteract___zh___default",
    path: "/analysis/shop/bloggerInteract",
    meta: bloggerInteractCTZLiBP746Meta || {},
    component: () => import("/app/pages/analysis/shop/bloggerInteract.vue").then(m => m.default || m)
  },
  {
    name: "analysis-shop-bloggerInteract___zh",
    path: "/zh/analysis/shop/bloggerInteract",
    meta: bloggerInteractCTZLiBP746Meta || {},
    component: () => import("/app/pages/analysis/shop/bloggerInteract.vue").then(m => m.default || m)
  },
  {
    name: "analysis-shop-bloggerInteract___pt",
    path: "/pt/analysis/shop/bloggerInteract",
    meta: bloggerInteractCTZLiBP746Meta || {},
    component: () => import("/app/pages/analysis/shop/bloggerInteract.vue").then(m => m.default || m)
  },
  {
    name: "analysis-shop-detail-id___en",
    path: "/en/analysis/shop/detail/:id()",
    meta: _91id_93jhLEC1HqhnMeta || {},
    component: () => import("/app/pages/analysis/shop/detail/[id].vue").then(m => m.default || m)
  },
  {
    name: "analysis-shop-detail-id___zh___default",
    path: "/analysis/shop/detail/:id()",
    meta: _91id_93jhLEC1HqhnMeta || {},
    component: () => import("/app/pages/analysis/shop/detail/[id].vue").then(m => m.default || m)
  },
  {
    name: "analysis-shop-detail-id___zh",
    path: "/zh/analysis/shop/detail/:id()",
    meta: _91id_93jhLEC1HqhnMeta || {},
    component: () => import("/app/pages/analysis/shop/detail/[id].vue").then(m => m.default || m)
  },
  {
    name: "analysis-shop-detail-id___pt",
    path: "/pt/analysis/shop/detail/:id()",
    meta: _91id_93jhLEC1HqhnMeta || {},
    component: () => import("/app/pages/analysis/shop/detail/[id].vue").then(m => m.default || m)
  },
  {
    name: "analysis-shop-hosting___en",
    path: "/en/analysis/shop/hosting",
    meta: hostingZl8UY9gg8gMeta || {},
    component: () => import("/app/pages/analysis/shop/hosting.vue").then(m => m.default || m)
  },
  {
    name: "analysis-shop-hosting___zh___default",
    path: "/analysis/shop/hosting",
    meta: hostingZl8UY9gg8gMeta || {},
    component: () => import("/app/pages/analysis/shop/hosting.vue").then(m => m.default || m)
  },
  {
    name: "analysis-shop-hosting___zh",
    path: "/zh/analysis/shop/hosting",
    meta: hostingZl8UY9gg8gMeta || {},
    component: () => import("/app/pages/analysis/shop/hosting.vue").then(m => m.default || m)
  },
  {
    name: "analysis-shop-hosting___pt",
    path: "/pt/analysis/shop/hosting",
    meta: hostingZl8UY9gg8gMeta || {},
    component: () => import("/app/pages/analysis/shop/hosting.vue").then(m => m.default || m)
  },
  {
    name: "analysis-shop-hotSale___en",
    path: "/en/analysis/shop/hotSale",
    meta: hotSaleAhiRrB7sPXMeta || {},
    component: () => import("/app/pages/analysis/shop/hotSale.vue").then(m => m.default || m)
  },
  {
    name: "analysis-shop-hotSale___zh___default",
    path: "/analysis/shop/hotSale",
    meta: hotSaleAhiRrB7sPXMeta || {},
    component: () => import("/app/pages/analysis/shop/hotSale.vue").then(m => m.default || m)
  },
  {
    name: "analysis-shop-hotSale___zh",
    path: "/zh/analysis/shop/hotSale",
    meta: hotSaleAhiRrB7sPXMeta || {},
    component: () => import("/app/pages/analysis/shop/hotSale.vue").then(m => m.default || m)
  },
  {
    name: "analysis-shop-hotSale___pt",
    path: "/pt/analysis/shop/hotSale",
    meta: hotSaleAhiRrB7sPXMeta || {},
    component: () => import("/app/pages/analysis/shop/hotSale.vue").then(m => m.default || m)
  },
  {
    name: "analysis-shop___en",
    path: "/en/analysis/shop",
    meta: indexePe1Rp0qLFMeta || {},
    component: () => import("/app/pages/analysis/shop/index.vue").then(m => m.default || m)
  },
  {
    name: "analysis-shop___zh___default",
    path: "/analysis/shop",
    meta: indexePe1Rp0qLFMeta || {},
    component: () => import("/app/pages/analysis/shop/index.vue").then(m => m.default || m)
  },
  {
    name: "analysis-shop___zh",
    path: "/zh/analysis/shop",
    meta: indexePe1Rp0qLFMeta || {},
    component: () => import("/app/pages/analysis/shop/index.vue").then(m => m.default || m)
  },
  {
    name: "analysis-shop___pt",
    path: "/pt/analysis/shop",
    meta: indexePe1Rp0qLFMeta || {},
    component: () => import("/app/pages/analysis/shop/index.vue").then(m => m.default || m)
  },
  {
    name: "analysis-video-detail-id___en",
    path: "/en/analysis/video/detail/:id()",
    meta: _91id_93KTHUBNq7d5Meta || {},
    component: () => import("/app/pages/analysis/video/detail/[id].vue").then(m => m.default || m)
  },
  {
    name: "analysis-video-detail-id___zh___default",
    path: "/analysis/video/detail/:id()",
    meta: _91id_93KTHUBNq7d5Meta || {},
    component: () => import("/app/pages/analysis/video/detail/[id].vue").then(m => m.default || m)
  },
  {
    name: "analysis-video-detail-id___zh",
    path: "/zh/analysis/video/detail/:id()",
    meta: _91id_93KTHUBNq7d5Meta || {},
    component: () => import("/app/pages/analysis/video/detail/[id].vue").then(m => m.default || m)
  },
  {
    name: "analysis-video-detail-id___pt",
    path: "/pt/analysis/video/detail/:id()",
    meta: _91id_93KTHUBNq7d5Meta || {},
    component: () => import("/app/pages/analysis/video/detail/[id].vue").then(m => m.default || m)
  },
  {
    name: "analysis-video-ecommerce___en",
    path: "/en/analysis/video/ecommerce",
    component: () => import("/app/pages/analysis/video/ecommerce.vue").then(m => m.default || m)
  },
  {
    name: "analysis-video-ecommerce___zh___default",
    path: "/analysis/video/ecommerce",
    component: () => import("/app/pages/analysis/video/ecommerce.vue").then(m => m.default || m)
  },
  {
    name: "analysis-video-ecommerce___zh",
    path: "/zh/analysis/video/ecommerce",
    component: () => import("/app/pages/analysis/video/ecommerce.vue").then(m => m.default || m)
  },
  {
    name: "analysis-video-ecommerce___pt",
    path: "/pt/analysis/video/ecommerce",
    component: () => import("/app/pages/analysis/video/ecommerce.vue").then(m => m.default || m)
  },
  {
    name: "analysis-video-hot___en",
    path: "/en/analysis/video/hot",
    component: () => import("/app/pages/analysis/video/hot.vue").then(m => m.default || m)
  },
  {
    name: "analysis-video-hot___zh___default",
    path: "/analysis/video/hot",
    component: () => import("/app/pages/analysis/video/hot.vue").then(m => m.default || m)
  },
  {
    name: "analysis-video-hot___zh",
    path: "/zh/analysis/video/hot",
    component: () => import("/app/pages/analysis/video/hot.vue").then(m => m.default || m)
  },
  {
    name: "analysis-video-hot___pt",
    path: "/pt/analysis/video/hot",
    component: () => import("/app/pages/analysis/video/hot.vue").then(m => m.default || m)
  },
  {
    name: "analysis-video___en",
    path: "/en/analysis/video",
    meta: indexyg5FbxbnzUMeta || {},
    component: () => import("/app/pages/analysis/video/index.vue").then(m => m.default || m)
  },
  {
    name: "analysis-video___zh___default",
    path: "/analysis/video",
    meta: indexyg5FbxbnzUMeta || {},
    component: () => import("/app/pages/analysis/video/index.vue").then(m => m.default || m)
  },
  {
    name: "analysis-video___zh",
    path: "/zh/analysis/video",
    meta: indexyg5FbxbnzUMeta || {},
    component: () => import("/app/pages/analysis/video/index.vue").then(m => m.default || m)
  },
  {
    name: "analysis-video___pt",
    path: "/pt/analysis/video",
    meta: indexyg5FbxbnzUMeta || {},
    component: () => import("/app/pages/analysis/video/index.vue").then(m => m.default || m)
  },
  {
    name: "blog-slug___en",
    path: "/en/blog/:slug()",
    meta: _91slug_93cdf2dv6FbPMeta || {},
    component: () => import("/app/pages/blog/[slug].vue").then(m => m.default || m)
  },
  {
    name: "blog-slug___zh___default",
    path: "/blog/:slug()",
    meta: _91slug_93cdf2dv6FbPMeta || {},
    component: () => import("/app/pages/blog/[slug].vue").then(m => m.default || m)
  },
  {
    name: "blog-slug___zh",
    path: "/zh/blog/:slug()",
    meta: _91slug_93cdf2dv6FbPMeta || {},
    component: () => import("/app/pages/blog/[slug].vue").then(m => m.default || m)
  },
  {
    name: "blog-slug___pt",
    path: "/pt/blog/:slug()",
    meta: _91slug_93cdf2dv6FbPMeta || {},
    component: () => import("/app/pages/blog/[slug].vue").then(m => m.default || m)
  },
  {
    name: "blog-event___en",
    path: "/en/blog/event",
    meta: eventrnRSHV1LeRMeta || {},
    component: () => import("/app/pages/blog/event.vue").then(m => m.default || m)
  },
  {
    name: "blog-event___zh___default",
    path: "/blog/event",
    meta: eventrnRSHV1LeRMeta || {},
    component: () => import("/app/pages/blog/event.vue").then(m => m.default || m)
  },
  {
    name: "blog-event___zh",
    path: "/zh/blog/event",
    meta: eventrnRSHV1LeRMeta || {},
    component: () => import("/app/pages/blog/event.vue").then(m => m.default || m)
  },
  {
    name: "blog-event___pt",
    path: "/pt/blog/event",
    meta: eventrnRSHV1LeRMeta || {},
    component: () => import("/app/pages/blog/event.vue").then(m => m.default || m)
  },
  {
    name: "blog___en",
    path: "/en/blog",
    meta: indexgWaMlevJ7RMeta || {},
    component: () => import("/app/pages/blog/index.vue").then(m => m.default || m)
  },
  {
    name: "blog___zh___default",
    path: "/blog",
    meta: indexgWaMlevJ7RMeta || {},
    component: () => import("/app/pages/blog/index.vue").then(m => m.default || m)
  },
  {
    name: "blog___zh",
    path: "/zh/blog",
    meta: indexgWaMlevJ7RMeta || {},
    component: () => import("/app/pages/blog/index.vue").then(m => m.default || m)
  },
  {
    name: "blog___pt",
    path: "/pt/blog",
    meta: indexgWaMlevJ7RMeta || {},
    component: () => import("/app/pages/blog/index.vue").then(m => m.default || m)
  },
  {
    name: "blog-market___en",
    path: "/en/blog/market",
    meta: marketvo5RpeWqlxMeta || {},
    component: () => import("/app/pages/blog/market.vue").then(m => m.default || m)
  },
  {
    name: "blog-market___zh___default",
    path: "/blog/market",
    meta: marketvo5RpeWqlxMeta || {},
    component: () => import("/app/pages/blog/market.vue").then(m => m.default || m)
  },
  {
    name: "blog-market___zh",
    path: "/zh/blog/market",
    meta: marketvo5RpeWqlxMeta || {},
    component: () => import("/app/pages/blog/market.vue").then(m => m.default || m)
  },
  {
    name: "blog-market___pt",
    path: "/pt/blog/market",
    meta: marketvo5RpeWqlxMeta || {},
    component: () => import("/app/pages/blog/market.vue").then(m => m.default || m)
  },
  {
    name: "blog-study-category___en",
    path: "/en/blog/study/:category()",
    meta: _91category_93PvkHdqkLZeMeta || {},
    component: () => import("/app/pages/blog/study/[category].vue").then(m => m.default || m)
  },
  {
    name: "blog-study-category___zh___default",
    path: "/blog/study/:category()",
    meta: _91category_93PvkHdqkLZeMeta || {},
    component: () => import("/app/pages/blog/study/[category].vue").then(m => m.default || m)
  },
  {
    name: "blog-study-category___zh",
    path: "/zh/blog/study/:category()",
    meta: _91category_93PvkHdqkLZeMeta || {},
    component: () => import("/app/pages/blog/study/[category].vue").then(m => m.default || m)
  },
  {
    name: "blog-study-category___pt",
    path: "/pt/blog/study/:category()",
    meta: _91category_93PvkHdqkLZeMeta || {},
    component: () => import("/app/pages/blog/study/[category].vue").then(m => m.default || m)
  },
  {
    name: "blog-study___en",
    path: "/en/blog/study",
    meta: indexBdHGb1d4asMeta || {},
    component: () => import("/app/pages/blog/study/index.vue").then(m => m.default || m)
  },
  {
    name: "blog-study___zh___default",
    path: "/blog/study",
    meta: indexBdHGb1d4asMeta || {},
    component: () => import("/app/pages/blog/study/index.vue").then(m => m.default || m)
  },
  {
    name: "blog-study___zh",
    path: "/zh/blog/study",
    meta: indexBdHGb1d4asMeta || {},
    component: () => import("/app/pages/blog/study/index.vue").then(m => m.default || m)
  },
  {
    name: "blog-study___pt",
    path: "/pt/blog/study",
    meta: indexBdHGb1d4asMeta || {},
    component: () => import("/app/pages/blog/study/index.vue").then(m => m.default || m)
  },
  {
    name: "content-slug___en",
    path: "/en/content/:slug()",
    meta: _91slug_933eBzGbcZ9XMeta || {},
    component: () => import("/app/pages/content/[slug].vue").then(m => m.default || m)
  },
  {
    name: "content-slug___zh___default",
    path: "/content/:slug()",
    meta: _91slug_933eBzGbcZ9XMeta || {},
    component: () => import("/app/pages/content/[slug].vue").then(m => m.default || m)
  },
  {
    name: "content-slug___zh",
    path: "/zh/content/:slug()",
    meta: _91slug_933eBzGbcZ9XMeta || {},
    component: () => import("/app/pages/content/[slug].vue").then(m => m.default || m)
  },
  {
    name: "content-slug___pt",
    path: "/pt/content/:slug()",
    meta: _91slug_933eBzGbcZ9XMeta || {},
    component: () => import("/app/pages/content/[slug].vue").then(m => m.default || m)
  },
  {
    name: "content-analysis___en",
    path: "/en/content/analysis",
    meta: analysistH66duiY95Meta || {},
    component: () => import("/app/pages/content/analysis.vue").then(m => m.default || m)
  },
  {
    name: "content-analysis___zh___default",
    path: "/content/analysis",
    meta: analysistH66duiY95Meta || {},
    component: () => import("/app/pages/content/analysis.vue").then(m => m.default || m)
  },
  {
    name: "content-analysis___zh",
    path: "/zh/content/analysis",
    meta: analysistH66duiY95Meta || {},
    component: () => import("/app/pages/content/analysis.vue").then(m => m.default || m)
  },
  {
    name: "content-analysis___pt",
    path: "/pt/content/analysis",
    meta: analysistH66duiY95Meta || {},
    component: () => import("/app/pages/content/analysis.vue").then(m => m.default || m)
  },
  {
    name: "content-detail-id___en",
    path: "/en/content/detail/:id()",
    meta: _91id_934xfDEMQK1fMeta || {},
    component: () => import("/app/pages/content/detail/[id].vue").then(m => m.default || m)
  },
  {
    name: "content-detail-id___zh___default",
    path: "/content/detail/:id()",
    meta: _91id_934xfDEMQK1fMeta || {},
    component: () => import("/app/pages/content/detail/[id].vue").then(m => m.default || m)
  },
  {
    name: "content-detail-id___zh",
    path: "/zh/content/detail/:id()",
    meta: _91id_934xfDEMQK1fMeta || {},
    component: () => import("/app/pages/content/detail/[id].vue").then(m => m.default || m)
  },
  {
    name: "content-detail-id___pt",
    path: "/pt/content/detail/:id()",
    meta: _91id_934xfDEMQK1fMeta || {},
    component: () => import("/app/pages/content/detail/[id].vue").then(m => m.default || m)
  },
  {
    name: "content___en",
    path: "/en/content",
    meta: indexryMIhEy6m5Meta || {},
    component: () => import("/app/pages/content/index.vue").then(m => m.default || m)
  },
  {
    name: "content___zh___default",
    path: "/content",
    meta: indexryMIhEy6m5Meta || {},
    component: () => import("/app/pages/content/index.vue").then(m => m.default || m)
  },
  {
    name: "content___zh",
    path: "/zh/content",
    meta: indexryMIhEy6m5Meta || {},
    component: () => import("/app/pages/content/index.vue").then(m => m.default || m)
  },
  {
    name: "content___pt",
    path: "/pt/content",
    meta: indexryMIhEy6m5Meta || {},
    component: () => import("/app/pages/content/index.vue").then(m => m.default || m)
  },
  {
    name: "content-news___en",
    path: "/en/content/news",
    meta: newsAdFAajK46MMeta || {},
    component: () => import("/app/pages/content/news.vue").then(m => m.default || m)
  },
  {
    name: "content-news___zh___default",
    path: "/content/news",
    meta: newsAdFAajK46MMeta || {},
    component: () => import("/app/pages/content/news.vue").then(m => m.default || m)
  },
  {
    name: "content-news___zh",
    path: "/zh/content/news",
    meta: newsAdFAajK46MMeta || {},
    component: () => import("/app/pages/content/news.vue").then(m => m.default || m)
  },
  {
    name: "content-news___pt",
    path: "/pt/content/news",
    meta: newsAdFAajK46MMeta || {},
    component: () => import("/app/pages/content/news.vue").then(m => m.default || m)
  },
  {
    name: "creative-contrast___en",
    path: "/en/creative/contrast",
    component: () => import("/app/pages/creative/contrast.vue").then(m => m.default || m)
  },
  {
    name: "creative-contrast___zh___default",
    path: "/creative/contrast",
    component: () => import("/app/pages/creative/contrast.vue").then(m => m.default || m)
  },
  {
    name: "creative-contrast___zh",
    path: "/zh/creative/contrast",
    component: () => import("/app/pages/creative/contrast.vue").then(m => m.default || m)
  },
  {
    name: "creative-contrast___pt",
    path: "/pt/creative/contrast",
    component: () => import("/app/pages/creative/contrast.vue").then(m => m.default || m)
  },
  {
    name: "creative___en",
    path: "/en/creative",
    component: () => import("/app/pages/creative/index.vue").then(m => m.default || m)
  },
  {
    name: "creative___zh___default",
    path: "/creative",
    component: () => import("/app/pages/creative/index.vue").then(m => m.default || m)
  },
  {
    name: "creative___zh",
    path: "/zh/creative",
    component: () => import("/app/pages/creative/index.vue").then(m => m.default || m)
  },
  {
    name: "creative___pt",
    path: "/pt/creative",
    component: () => import("/app/pages/creative/index.vue").then(m => m.default || m)
  },
  {
    name: "excel-image-tutorial___en",
    path: "/en/excel-image-tutorial",
    meta: excel_45image_45tutoriallfzrtrj7UvMeta || {},
    component: () => import("/app/pages/excel-image-tutorial.vue").then(m => m.default || m)
  },
  {
    name: "excel-image-tutorial___zh___default",
    path: "/excel-image-tutorial",
    meta: excel_45image_45tutoriallfzrtrj7UvMeta || {},
    component: () => import("/app/pages/excel-image-tutorial.vue").then(m => m.default || m)
  },
  {
    name: "excel-image-tutorial___zh",
    path: "/zh/excel-image-tutorial",
    meta: excel_45image_45tutoriallfzrtrj7UvMeta || {},
    component: () => import("/app/pages/excel-image-tutorial.vue").then(m => m.default || m)
  },
  {
    name: "excel-image-tutorial___pt",
    path: "/pt/excel-image-tutorial",
    meta: excel_45image_45tutoriallfzrtrj7UvMeta || {},
    component: () => import("/app/pages/excel-image-tutorial.vue").then(m => m.default || m)
  },
  {
    name: "favourites___en",
    path: "/en/favourites",
    component: () => import("/app/pages/favourites.vue").then(m => m.default || m),
    children: [
  {
    name: "favourites-blogger___en",
    path: "blogger",
    component: () => import("/app/pages/favourites/blogger.vue").then(m => m.default || m)
  },
  {
    name: "favourites-live___en",
    path: "live",
    component: () => import("/app/pages/favourites/live.vue").then(m => m.default || m)
  },
  {
    name: "favourites-product___en",
    path: "product",
    component: () => import("/app/pages/favourites/product.vue").then(m => m.default || m)
  },
  {
    name: "favourites-shop___en",
    path: "shop",
    component: () => import("/app/pages/favourites/shop.vue").then(m => m.default || m)
  },
  {
    name: "favourites-video___en",
    path: "video",
    component: () => import("/app/pages/favourites/video.vue").then(m => m.default || m)
  }
]
  },
  {
    name: "favourites___zh___default",
    path: "/favourites",
    component: () => import("/app/pages/favourites.vue").then(m => m.default || m),
    children: [
  {
    name: "favourites-blogger___zh___default",
    path: "blogger",
    component: () => import("/app/pages/favourites/blogger.vue").then(m => m.default || m)
  },
  {
    name: "favourites-live___zh___default",
    path: "live",
    component: () => import("/app/pages/favourites/live.vue").then(m => m.default || m)
  },
  {
    name: "favourites-product___zh___default",
    path: "product",
    component: () => import("/app/pages/favourites/product.vue").then(m => m.default || m)
  },
  {
    name: "favourites-shop___zh___default",
    path: "shop",
    component: () => import("/app/pages/favourites/shop.vue").then(m => m.default || m)
  },
  {
    name: "favourites-video___zh___default",
    path: "video",
    component: () => import("/app/pages/favourites/video.vue").then(m => m.default || m)
  }
]
  },
  {
    name: "favourites___zh",
    path: "/zh/favourites",
    component: () => import("/app/pages/favourites.vue").then(m => m.default || m),
    children: [
  {
    name: "favourites-blogger___zh",
    path: "blogger",
    component: () => import("/app/pages/favourites/blogger.vue").then(m => m.default || m)
  },
  {
    name: "favourites-live___zh",
    path: "live",
    component: () => import("/app/pages/favourites/live.vue").then(m => m.default || m)
  },
  {
    name: "favourites-product___zh",
    path: "product",
    component: () => import("/app/pages/favourites/product.vue").then(m => m.default || m)
  },
  {
    name: "favourites-shop___zh",
    path: "shop",
    component: () => import("/app/pages/favourites/shop.vue").then(m => m.default || m)
  },
  {
    name: "favourites-video___zh",
    path: "video",
    component: () => import("/app/pages/favourites/video.vue").then(m => m.default || m)
  }
]
  },
  {
    name: "favourites___pt",
    path: "/pt/favourites",
    component: () => import("/app/pages/favourites.vue").then(m => m.default || m),
    children: [
  {
    name: "favourites-blogger___pt",
    path: "blogger",
    component: () => import("/app/pages/favourites/blogger.vue").then(m => m.default || m)
  },
  {
    name: "favourites-live___pt",
    path: "live",
    component: () => import("/app/pages/favourites/live.vue").then(m => m.default || m)
  },
  {
    name: "favourites-product___pt",
    path: "product",
    component: () => import("/app/pages/favourites/product.vue").then(m => m.default || m)
  },
  {
    name: "favourites-shop___pt",
    path: "shop",
    component: () => import("/app/pages/favourites/shop.vue").then(m => m.default || m)
  },
  {
    name: "favourites-video___pt",
    path: "video",
    component: () => import("/app/pages/favourites/video.vue").then(m => m.default || m)
  }
]
  },
  {
    name: "index___en",
    path: "/en",
    meta: indexN6pT4Un8hYMeta || {},
    component: () => import("/app/pages/index.vue").then(m => m.default || m)
  },
  {
    name: "index___zh___default",
    path: "/",
    meta: indexN6pT4Un8hYMeta || {},
    component: () => import("/app/pages/index.vue").then(m => m.default || m)
  },
  {
    name: "index___zh",
    path: "/zh",
    meta: indexN6pT4Un8hYMeta || {},
    component: () => import("/app/pages/index.vue").then(m => m.default || m)
  },
  {
    name: "index___pt",
    path: "/pt",
    meta: indexN6pT4Un8hYMeta || {},
    component: () => import("/app/pages/index.vue").then(m => m.default || m)
  },
  {
    name: "invite___en",
    path: "/en/invite",
    meta: invitebE9by1aL3FMeta || {},
    component: () => import("/app/pages/invite.vue").then(m => m.default || m)
  },
  {
    name: "invite___zh___default",
    path: "/invite",
    meta: invitebE9by1aL3FMeta || {},
    component: () => import("/app/pages/invite.vue").then(m => m.default || m)
  },
  {
    name: "invite___zh",
    path: "/zh/invite",
    meta: invitebE9by1aL3FMeta || {},
    component: () => import("/app/pages/invite.vue").then(m => m.default || m)
  },
  {
    name: "invite___pt",
    path: "/pt/invite",
    meta: invitebE9by1aL3FMeta || {},
    component: () => import("/app/pages/invite.vue").then(m => m.default || m)
  },
  {
    name: "marketing-analysis___en",
    path: "/en/marketing/analysis",
    component: () => import("/app/pages/marketing/analysis.vue").then(m => m.default || m)
  },
  {
    name: "marketing-analysis___zh___default",
    path: "/marketing/analysis",
    component: () => import("/app/pages/marketing/analysis.vue").then(m => m.default || m)
  },
  {
    name: "marketing-analysis___zh",
    path: "/zh/marketing/analysis",
    component: () => import("/app/pages/marketing/analysis.vue").then(m => m.default || m)
  },
  {
    name: "marketing-analysis___pt",
    path: "/pt/marketing/analysis",
    component: () => import("/app/pages/marketing/analysis.vue").then(m => m.default || m)
  },
  {
    name: "marketing-overview___en",
    path: "/en/marketing/overview",
    component: () => import("/app/pages/marketing/overview.vue").then(m => m.default || m)
  },
  {
    name: "marketing-overview___zh___default",
    path: "/marketing/overview",
    component: () => import("/app/pages/marketing/overview.vue").then(m => m.default || m)
  },
  {
    name: "marketing-overview___zh",
    path: "/zh/marketing/overview",
    component: () => import("/app/pages/marketing/overview.vue").then(m => m.default || m)
  },
  {
    name: "marketing-overview___pt",
    path: "/pt/marketing/overview",
    component: () => import("/app/pages/marketing/overview.vue").then(m => m.default || m)
  },
  {
    name: "marketing-segment-detail-id___en",
    path: "/en/marketing/segment/detail/:id()",
    meta: _91id_93ajJAov56K2Meta || {},
    component: () => import("/app/pages/marketing/segment/detail/[id].vue").then(m => m.default || m)
  },
  {
    name: "marketing-segment-detail-id___zh___default",
    path: "/marketing/segment/detail/:id()",
    meta: _91id_93ajJAov56K2Meta || {},
    component: () => import("/app/pages/marketing/segment/detail/[id].vue").then(m => m.default || m)
  },
  {
    name: "marketing-segment-detail-id___zh",
    path: "/zh/marketing/segment/detail/:id()",
    meta: _91id_93ajJAov56K2Meta || {},
    component: () => import("/app/pages/marketing/segment/detail/[id].vue").then(m => m.default || m)
  },
  {
    name: "marketing-segment-detail-id___pt",
    path: "/pt/marketing/segment/detail/:id()",
    meta: _91id_93ajJAov56K2Meta || {},
    component: () => import("/app/pages/marketing/segment/detail/[id].vue").then(m => m.default || m)
  },
  {
    name: "marketing-segment___en",
    path: "/en/marketing/segment",
    meta: indexFoa8368a6XMeta || {},
    component: () => import("/app/pages/marketing/segment/index.vue").then(m => m.default || m)
  },
  {
    name: "marketing-segment___zh___default",
    path: "/marketing/segment",
    meta: indexFoa8368a6XMeta || {},
    component: () => import("/app/pages/marketing/segment/index.vue").then(m => m.default || m)
  },
  {
    name: "marketing-segment___zh",
    path: "/zh/marketing/segment",
    meta: indexFoa8368a6XMeta || {},
    component: () => import("/app/pages/marketing/segment/index.vue").then(m => m.default || m)
  },
  {
    name: "marketing-segment___pt",
    path: "/pt/marketing/segment",
    meta: indexFoa8368a6XMeta || {},
    component: () => import("/app/pages/marketing/segment/index.vue").then(m => m.default || m)
  },
  {
    name: "pay-pt___en",
    path: "/en/pay/pt",
    meta: pt3NYoboDcLsMeta || {},
    component: () => import("/app/pages/pay/pt.vue").then(m => m.default || m)
  },
  {
    name: "pay-pt___zh___default",
    path: "/pay/pt",
    meta: pt3NYoboDcLsMeta || {},
    component: () => import("/app/pages/pay/pt.vue").then(m => m.default || m)
  },
  {
    name: "pay-pt___zh",
    path: "/zh/pay/pt",
    meta: pt3NYoboDcLsMeta || {},
    component: () => import("/app/pages/pay/pt.vue").then(m => m.default || m)
  },
  {
    name: "pay-pt___pt",
    path: "/pt/pay/pt",
    meta: pt3NYoboDcLsMeta || {},
    component: () => import("/app/pages/pay/pt.vue").then(m => m.default || m)
  },
  {
    name: "privacy___en",
    path: "/en/privacy",
    meta: privacyg3gwBRGXatMeta || {},
    component: () => import("/app/pages/privacy.vue").then(m => m.default || m)
  },
  {
    name: "privacy___zh___default",
    path: "/privacy",
    meta: privacyg3gwBRGXatMeta || {},
    component: () => import("/app/pages/privacy.vue").then(m => m.default || m)
  },
  {
    name: "privacy___zh",
    path: "/zh/privacy",
    meta: privacyg3gwBRGXatMeta || {},
    component: () => import("/app/pages/privacy.vue").then(m => m.default || m)
  },
  {
    name: "privacy___pt",
    path: "/pt/privacy",
    meta: privacyg3gwBRGXatMeta || {},
    component: () => import("/app/pages/privacy.vue").then(m => m.default || m)
  },
  {
    name: "service___en",
    path: "/en/service",
    meta: serviceOjoihKJKpkMeta || {},
    component: () => import("/app/pages/service.vue").then(m => m.default || m)
  },
  {
    name: "service___zh___default",
    path: "/service",
    meta: serviceOjoihKJKpkMeta || {},
    component: () => import("/app/pages/service.vue").then(m => m.default || m)
  },
  {
    name: "service___zh",
    path: "/zh/service",
    meta: serviceOjoihKJKpkMeta || {},
    component: () => import("/app/pages/service.vue").then(m => m.default || m)
  },
  {
    name: "service___pt",
    path: "/pt/service",
    meta: serviceOjoihKJKpkMeta || {},
    component: () => import("/app/pages/service.vue").then(m => m.default || m)
  },
  {
    name: "tool-bloggerMonitor___en",
    path: "/en/tool/bloggerMonitor",
    meta: bloggerMonitorYPKxvI7WQwMeta || {},
    component: () => import("/app/pages/tool/bloggerMonitor.vue").then(m => m.default || m)
  },
  {
    name: "tool-bloggerMonitor___zh___default",
    path: "/tool/bloggerMonitor",
    meta: bloggerMonitorYPKxvI7WQwMeta || {},
    component: () => import("/app/pages/tool/bloggerMonitor.vue").then(m => m.default || m)
  },
  {
    name: "tool-bloggerMonitor___zh",
    path: "/zh/tool/bloggerMonitor",
    meta: bloggerMonitorYPKxvI7WQwMeta || {},
    component: () => import("/app/pages/tool/bloggerMonitor.vue").then(m => m.default || m)
  },
  {
    name: "tool-bloggerMonitor___pt",
    path: "/pt/tool/bloggerMonitor",
    meta: bloggerMonitorYPKxvI7WQwMeta || {},
    component: () => import("/app/pages/tool/bloggerMonitor.vue").then(m => m.default || m)
  },
  {
    name: "tool-bloggers___en",
    path: "/en/tool/bloggers",
    meta: bloggers31RjXDiUlJMeta || {},
    component: () => import("/app/pages/tool/bloggers.vue").then(m => m.default || m)
  },
  {
    name: "tool-bloggers___zh___default",
    path: "/tool/bloggers",
    meta: bloggers31RjXDiUlJMeta || {},
    component: () => import("/app/pages/tool/bloggers.vue").then(m => m.default || m)
  },
  {
    name: "tool-bloggers___zh",
    path: "/zh/tool/bloggers",
    meta: bloggers31RjXDiUlJMeta || {},
    component: () => import("/app/pages/tool/bloggers.vue").then(m => m.default || m)
  },
  {
    name: "tool-bloggers___pt",
    path: "/pt/tool/bloggers",
    meta: bloggers31RjXDiUlJMeta || {},
    component: () => import("/app/pages/tool/bloggers.vue").then(m => m.default || m)
  },
  {
    name: "tool-pay___en",
    path: "/en/tool/pay",
    meta: pay3ZDuAlPusyMeta || {},
    component: () => import("/app/pages/tool/pay.vue").then(m => m.default || m)
  },
  {
    name: "tool-pay___zh___default",
    path: "/tool/pay",
    meta: pay3ZDuAlPusyMeta || {},
    component: () => import("/app/pages/tool/pay.vue").then(m => m.default || m)
  },
  {
    name: "tool-pay___zh",
    path: "/zh/tool/pay",
    meta: pay3ZDuAlPusyMeta || {},
    component: () => import("/app/pages/tool/pay.vue").then(m => m.default || m)
  },
  {
    name: "tool-pay___pt",
    path: "/pt/tool/pay",
    meta: pay3ZDuAlPusyMeta || {},
    component: () => import("/app/pages/tool/pay.vue").then(m => m.default || m)
  },
  {
    name: "tool-videoMonitor___en",
    path: "/en/tool/videoMonitor",
    meta: videoMonitor401vq3KfplMeta || {},
    component: () => import("/app/pages/tool/videoMonitor.vue").then(m => m.default || m)
  },
  {
    name: "tool-videoMonitor___zh___default",
    path: "/tool/videoMonitor",
    meta: videoMonitor401vq3KfplMeta || {},
    component: () => import("/app/pages/tool/videoMonitor.vue").then(m => m.default || m)
  },
  {
    name: "tool-videoMonitor___zh",
    path: "/zh/tool/videoMonitor",
    meta: videoMonitor401vq3KfplMeta || {},
    component: () => import("/app/pages/tool/videoMonitor.vue").then(m => m.default || m)
  },
  {
    name: "tool-videoMonitor___pt",
    path: "/pt/tool/videoMonitor",
    meta: videoMonitor401vq3KfplMeta || {},
    component: () => import("/app/pages/tool/videoMonitor.vue").then(m => m.default || m)
  },
  {
    name: "user___en",
    path: "/en/user",
    component: () => import("/app/pages/user.vue").then(m => m.default || m),
    children: [
  {
    name: "user-info___en",
    path: "info",
    component: () => import("/app/pages/user/info.vue").then(m => m.default || m)
  },
  {
    name: "user-member___en",
    path: "member",
    component: () => import("/app/pages/user/member.vue").then(m => m.default || m)
  },
  {
    name: "user-order___en",
    path: "order",
    component: () => import("/app/pages/user/order.vue").then(m => m.default || m)
  }
]
  },
  {
    name: "user___zh___default",
    path: "/user",
    component: () => import("/app/pages/user.vue").then(m => m.default || m),
    children: [
  {
    name: "user-info___zh___default",
    path: "info",
    component: () => import("/app/pages/user/info.vue").then(m => m.default || m)
  },
  {
    name: "user-member___zh___default",
    path: "member",
    component: () => import("/app/pages/user/member.vue").then(m => m.default || m)
  },
  {
    name: "user-order___zh___default",
    path: "order",
    component: () => import("/app/pages/user/order.vue").then(m => m.default || m)
  }
]
  },
  {
    name: "user___zh",
    path: "/zh/user",
    component: () => import("/app/pages/user.vue").then(m => m.default || m),
    children: [
  {
    name: "user-info___zh",
    path: "info",
    component: () => import("/app/pages/user/info.vue").then(m => m.default || m)
  },
  {
    name: "user-member___zh",
    path: "member",
    component: () => import("/app/pages/user/member.vue").then(m => m.default || m)
  },
  {
    name: "user-order___zh",
    path: "order",
    component: () => import("/app/pages/user/order.vue").then(m => m.default || m)
  }
]
  },
  {
    name: "user___pt",
    path: "/pt/user",
    component: () => import("/app/pages/user.vue").then(m => m.default || m),
    children: [
  {
    name: "user-info___pt",
    path: "info",
    component: () => import("/app/pages/user/info.vue").then(m => m.default || m)
  },
  {
    name: "user-member___pt",
    path: "member",
    component: () => import("/app/pages/user/member.vue").then(m => m.default || m)
  },
  {
    name: "user-order___pt",
    path: "order",
    component: () => import("/app/pages/user/order.vue").then(m => m.default || m)
  }
]
  },
  {
    name: "vip-check___en",
    path: "/en/vip/check",
    component: () => import("/app/pages/vip/check.vue").then(m => m.default || m)
  },
  {
    name: "vip-check___zh___default",
    path: "/vip/check",
    component: () => import("/app/pages/vip/check.vue").then(m => m.default || m)
  },
  {
    name: "vip-check___zh",
    path: "/zh/vip/check",
    component: () => import("/app/pages/vip/check.vue").then(m => m.default || m)
  },
  {
    name: "vip-check___pt",
    path: "/pt/vip/check",
    component: () => import("/app/pages/vip/check.vue").then(m => m.default || m)
  },
  {
    name: "vip___en",
    path: "/en/vip",
    meta: indextrgzWvQsEDMeta || {},
    component: () => import("/app/pages/vip/index.vue").then(m => m.default || m)
  },
  {
    name: "vip___zh___default",
    path: "/vip",
    meta: indextrgzWvQsEDMeta || {},
    component: () => import("/app/pages/vip/index.vue").then(m => m.default || m)
  },
  {
    name: "vip___zh",
    path: "/zh/vip",
    meta: indextrgzWvQsEDMeta || {},
    component: () => import("/app/pages/vip/index.vue").then(m => m.default || m)
  },
  {
    name: "vip___pt",
    path: "/pt/vip",
    meta: indextrgzWvQsEDMeta || {},
    component: () => import("/app/pages/vip/index.vue").then(m => m.default || m)
  }
]